// import Dashboard from "../pages/dashboard/Dashboard";

import Login from "../pages/authentication/Login";
import ForgotPassword from "../pages/authentication/ForgotPassword";
import SetPassword from "../pages/authentication/SetPassword";
import Dashboard from "../pages/dashboard/Dashboard";
import UserProfiles from "../pages/userProfiles/UserProfiles";
import UserDetails from "../pages/userProfiles/UserDetails";
import JobDetails from "../pages/job/JobDetails";
import JobList from "../pages/job/JobList";
import BlogDetails from "../pages/blog/BlogDetails";
import BlogList from "../pages/blog/BlogList";
import Location from "../pages/location/Location";
import SubscriberList from "../pages/subscriberList/SubscriberList";
import UserLogs from "../pages/userLogs/UserLogs";
import CVList from "../pages/cvList/CVList";
import SubmittedForms from "../pages/submittedForms/SubmittedForms";
import ContactUsList from "../pages/contactusList/ContactUsList";
import FormList from "../pages/dynamicForms/FormList";
import FormDetails from "../pages/dynamicForms/FormDetails";
import ScoreFormDetails from "../pages/dynamicForms/ScoreFormDetails";
import Policy from "../pages/policy/Policy";
import TimesheetExpense from "../pages/submittedForms/TimesheetExpense";
import SafeguardingForm from "../pages/submittedForms/SafeguardingForm";
import TimesheetDetails from "../pages/submittedForms/TimesheetDetails";
import Configuration from "../pages/configuration/Configuration";
import EOM from "../pages/eom/EOM";
import EOMSubmissions from "../pages/eomSubmissions/EOMSubmissions";
import HouseMasterList from "../pages/houseMaster/HouseMasterList";
import HouseMasterDetails from "../pages/houseMaster/HouseMasterDetails";
import VisitorReportsList from "../pages/visitorReports/VisitorReportsList";

const ComponentNavigation = [

  {
    path: "login",
    title: "Login",
    component: Login,
    hasParams: false,
    roles: [1, 2, 3]
  },
  {
    path: "forgot-password",
    title: "Forgot password",
    component: ForgotPassword,
    hasParams: false,
    roles: [1, 2, 3]
  },
  {
    path: "set-password",
    title: "Set password",
    component: SetPassword,
    hasParams: false,
    roles: [1, 2, 3]
  },
  {
    path: "dashboard",
    title: "Dashboard",
    component: Dashboard,
    hasParams: false,
    roles: [1, 2]
  },
  {
    path: "users-list",
    title: "User profiles",
    component: UserProfiles,
    hasParams: false,
    roles: [1]
  },
  {
    path: "users-details",
    title: "User details",
    previousPath: "User profiles",
    component: UserDetails,
    hasParams: false,
    roles: [1]
  },
  {
    path: "jobs",
    title: "Jobs",
    component: JobList,
    hasParams: false,
    roles: [1, 2] // Admin and Super Admin only
  },
  {
    path: "job-details",
    title: "Job details",
    previousPath: "Jobs",
    component: JobDetails,
    hasParams: false,
    roles: [1, 2] // Admin and Super Admin only
  },
  {
    path: "blogs",
    title: "Blogs",
    component: BlogList,
    hasParams: false,
    roles: [1, 2] // Admin and Super Admin only
  },
  {
    path: "blog-details",
    title: "Blog details",
    previousPath: "Blogs",
    component: BlogDetails,
    hasParams: false,
    roles: [1, 2] // Admin and Super Admin only
  },
  {
    path: "locations",
    title: "Locations",
    component: Location,
    hasParams: false,
    roles: [1, 2] // Admin and Super Admin only
  },
  {
    path: "policy",
    title: "Policy",
    component: Policy,
    hasParams: false,
    roles: [1, 2] // Admin and Super Admin only
  },
  {
    path: "subscribers-list",
    title: "Subscribers",
    component: SubscriberList,
    hasParams: false,
    roles: [1] // Super Admin only
  },
  {
    path: "form-list",
    title: "Form List",
    component: FormList,
    hasParams: false,
    roles: [1, 2] // Admin and Super Admin only
  },
  {
    path: "add-form",
    title: "Add New Form",
    component: FormDetails,
    hasParams: false,
    roles: [1, 2] // Admin and Super Admin only
  },
  {
    path: "add-score-form",
    title: "Add Assessment Form",
    component: ScoreFormDetails,
    hasParams: false,
    roles: [1, 2] // Admin and Super Admin only
  },
  {
    path: "cv-list",
    title: "CV list",
    component: CVList,
    hasParams: false,
    roles: [1, 2]
  },
  {
    path: "user-logs",
    title: "User logs",
    component: UserLogs,
    hasParams: false,
    roles: [1]
  },
  {
    path: "submitted-forms",
    title: "Submitted Forms",
    component: SubmittedForms,
    hasParams: false,
    roles: [1, 2]
  },
  {
    path: "timesheet-expense",
    title: "Timesheet & Expense",
    component: TimesheetExpense,
    hasParams: false,
    roles: [1, 2]
  },
  {
    path: "timesheet-details",
    title: "Timesheet Details",
    component: TimesheetDetails,
    hasParams: false,
    roles: [1, 2]
  },
  {
    path: "safeguarding-form",
    title: "Safegurading Forms",
    component: SafeguardingForm,
    hasParams: false,
    roles: [1, 2]
  },
  {
    path: "inquiry-report",
    title: "Contact Us Submissions",
    component: ContactUsList,
    hasParams: false,
    roles: [1, 2]
  },
  {
    path: "eom",
    title: "Employee of the Month",
    component: EOM,
    hasParams: false,
    roles: [1, 2] // Admin and Super Admin only
  },
  {
    path: "eom-submissions",
    title: "EOM Submissions",
    component: EOMSubmissions,
    hasParams: false,
    roles: [1, 2]
  },
  {
    path: "configuration",
    title: "Configuration",
    component: Configuration,
    hasParams: false,
    roles: [1, 2] // Admin and Super Admin only
  },
  {
    path: "house-master",
    title: "House Master",
    component: HouseMasterList,
    hasParams: false,
    roles: [1] // Super Admin only
  },
  {
    path: "house-details",
    title: "House Detail",
    previousPath: "House Master",
    component: HouseMasterDetails,
    hasParams: false,
    roles: [1] // Super Admin only
  },
  {
    path: "visitor-reports",
    title: "Visitor Reports",
    component: VisitorReportsList,
    hasParams: false,
    roles: [1, 2, 3]
  },

];
export default ComponentNavigation;